'use client';
import { Spin } from 'antd';
import { PropsWithChildren, useEffect, useState } from 'react';

const ClientRenderComp: React.FC<PropsWithChildren> = (props) => {
    const [render, setRender] = useState<boolean>(false);

    useEffect(() => {
        setRender(true);
    }, []);

    if (render) return props.children;
    else
        return (
            <div className={`w-100 pv-9 center-content flex-1`}>
                <Spin />
            </div>
        );
};
export default ClientRenderComp;
